import { connect } from 'react-redux';

import {
  getMetainf,
  getProjectZoneId,
  getUsersEvent,
  getUsersFilter,
} from '../../reducers/analyticsApp';
import {
  addFilterClause,
  copyFilter,
  removeFilter,
  removeFilterClause,
  setClausesConcatOperator,
  setFilterClauseOperator,
  setFilterClauseField,
  setFilterClauseValue,
  setFilterVisibility,
} from '../../actions/users';
import EventFilterContainer from '../../components/filter/EventFilterContainer';
import { filterClauses, isNotEmptyClause } from '../../utils/filter';

const mapStateToProps = (state) => {
  const filter = getUsersFilter(state);

  return {
    eventId: 0,
    metainf: getMetainf(state, getUsersEvent(state)),
    zoneId: getProjectZoneId(state),
    concatOperator: filter.concatOperator,
    clauses: filter.clauses,
    visibility: filter.visibility,
    badgeCount: filter.clauses.filter(isNotEmptyClause).length,
  };
};

const mapDispatchToProps = (dispatch) => ({
  setFilterVisibility: () => dispatch(setFilterVisibility()),
  onAddFilterClause: (...rest) => dispatch(addFilterClause(...rest)),
  onCopy: (...rest) => dispatch(copyFilter(...rest)),
  onRemoveFilter: () => dispatch(removeFilter(0)),
  onRemoveFilterClause: (...rest) => dispatch(removeFilterClause(...rest)),
  onSelectFilterClauseField: (...rest) => dispatch(setFilterClauseField(...rest)),
  onFilterClauseValueChange: (...rest) => dispatch(setFilterClauseValue(...rest)),
  onSetClausesConcatOperator: (...rest) => dispatch(setClausesConcatOperator(...rest)),
  onSelectFilterClauseOperator: (...rest) => dispatch(setFilterClauseOperator(...rest)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onCopyFilter: (copyFilters) =>
    dispatchProps.onCopy(filterClauses(stateProps.metainf, copyFilters)),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(EventFilterContainer);
